/* eslint-disable */
<template class="white-content">
  <div id="app">
    <div class="content">
      <notifications></notifications>
      <router-view :key="$route.fullPath"></router-view>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    disableRTL() {
      if (!this.$rtl.isRTL) {
        this.$rtl.disableRTL();
      }
    },
    toggleNavOpen() {
      let root = document.getElementsByTagName("html")[0];
      root.classList.toggle("nav-open");
    },
  },
  mounted() {
    this.$watch("$route", this.disableRTL, { immediate: true });
    this.$watch("$sidebar.showSidebar", this.toggleNavOpen);
  },
};
</script>

<style lang="scss">
.comparador .el-select--large input.el-input__inner {
  height: 45px !important;
}
.el-range-editor.el-input__inner {
  height: 45px !important;
  border-radius: 3px !important;
}
.pointer.footer-link {
  color: #ba54f5;
  font-weight: 300;
}
.pointer {
  cursor: pointer;
}
.btn-primary,
.sidebar {
  background: #243024 !important;
}
.modal .modal-header .close {
  color: #243024 !important;
}
.modal-content .modal-header i.tim-icons {
  font-weight: 700;
}
span.percentagem.negativo {
  font-weight: bold;
  color: red;
}
span.percentagem.positivo {
  font-weight: bold;
  color: #228b22;
}
// li#step-1,
// li#step-2,
// li#step-3 {
//   background: #d9d9d9;
// }
button.btn.btn-previous-wizard.btn-success {
  background: #999 !important;
}
span.percentagem.neutro {
  font-weight: bold;
  color: #243024;
}
.card-wizard .card-footer .pull-left {
  padding-left: 0px !important;
}
.card-wizard .card-footer .pull-right {
  padding-right: 0px !important;
}
.sidebar:before,
.off-canvas-sidebar:before {
  border-bottom-color: #243024 !important;
}
.card-wizard[data-color="green"] .progress-with-circle .progress-bar {
  background: #243024 !important;
}

span.fc-time {
  display: none;
}
.vermelhoNegativo {
  color: red !important;
}
.verdePositivo {
  color: #228b22 !important;
}
.neutro {
  font-weight: bold;
  color: #243024;
}
.icon-verde {
  background: #228b22 !important;
}
.icon-vermelho {
  background: red !important;
}
.icon-verde-gerencia {
  background: #243024 !important;
}
.wizard-navigation .nav-link {
  background: #d3d7e9 !important;
  color: #243024 !important;
}
.wizard-navigation .nav-link:not(.checked) {
  background: #d3d7e9 !important;
  color: #243024 !important;
}
.wizard-navigation .nav-link.checked {
  background: #243024 !important;
  color: #fff !important;
}
.icon-verde-gerencia-cor {
  color: #243024 !important;
}
.loading-overlay {
  display: flex;
  background: rgba(36, 48, 36, 0.8);
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  z-index: 9998;
  align-items: center;
  justify-content: center;
}

.loading-overlay.is-active {
  display: flex;
}
span.fas.fa-spinner.fa-3x.fa-spin {
  color: #fff !important;
}
.table-responsive {
  overflow: scroll;
  padding-bottom: 10px;
  max-height: 100vh;
  height: auto;
}
nav .container-fluid {
  padding-bottom: 0px !important;
}
h3.card-title {
  font-size: 18px !important;
  font-weight: 600 !important;
}
span.quantidadeTitle {
  font-size: 14px;
}
h5.card-category {
  font-weight: 600 !important;
  font-size: 0.7500000025rem !important;
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.row.customizar {
  background: white;
  margin: 0 !important;
  padding: 15px;
}
.space-between {
  padding-right: 15px;
  padding-left: 15px;
  justify-content: space-between;
}
.descricaoComparador .restaurante {
  color: #2c3e50;
  font-weight: 700;
}
.transparent input {
  background: transparent !important;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.row {
  display: flex;
  flex-wrap: wrap;
}
.g-3,
.gx-3 {
  --bs-gutter-x: 1rem !important;
}
p.BigPercentage {
  font-size: 2.2vw;
  font-weight: 500;
}
.col-lg-3,
.col-md-6 {
  display: flex;
  flex-direction: column;
}

.card {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.card-body {
  flex: 1;
}

.card-footer {
  margin-top: auto;
}
.modal-body {
  overflow-y: scroll;
  height: auto;
  min-height: 20vh;
  max-height: 80vh;
}
.modal-dialog {
  max-width: 50% !important;
}
.fc-event {
  padding: 10px !important;
}
.bold {
  font-weight: 700;
}
span.dataPequena {
  font-weight: 400;
  font-size: 12px;
}
.text-area {
  padding: 10px !important;
  border: 1px solid rgba(29, 37, 59, 0.5) !important;
  border-radius: 5px !important;
}
.botaoEnviarNotificacoes.ativo {
  color: #fff !important;
  background: #243024 !important;
}
.botaoEnviarNotificacoes {
  background: #e9e9e9 !important;
  color: #243024 !important;
}
.botaoEnviarNotificacoes:hover {
  color: #fff !important;
  background: #243024 !important;
}
.filtragem .el-select.select-info.el-select--large {
  width: 100% !important;
}
.centrarVerticalmente {
  align-items: center !important;
}
span.restaurante {
  font-weight: bold;
  font-size: 16px;
}
span.text-green {
  font-weight: 700;
  color: green;
}
</style>
